// @ts-strict-ignore
import sw from '../utils/switch'
import * as act from '../redux/contentful-actions'

import { findIncludes, simplifyCtx } from '../utils/contentful'
import { processProductTableSchema } from '../utils/deep-merge-product-tables'

export default (state = {}, { type, payload }) =>
  sw({
    [act.SET_BREADCRUMB]: (breadcrumb) => ({ ...state, breadcrumb }),
    [act.SET_PAGE_DATES]: (dates) => ({ ...state, dates }),
    [act.SET_CTX]: (ctx) => ({ ...state, ctx }),
    [act.SET_PRODUCT_TABLE_SCHEMA]: (ctx) => {
      const includes = ctx.includes
      const productTables = findIncludes(includes, 'productTableSchema')
      // Only add to the state if there actually is a product table
      let productTable

      let productTablesObject = {}

      if (productTables.length > 0) {
        productTablesObject = productTables.reduce(
          (tables, current) => ({
            ...tables,
            [current?.sys?.id]: processProductTableSchema(includes, current),
          }),
          {},
        )

        productTable = processProductTableSchema(includes, productTables[0])
      }

      return { ...state, productTable, productTables: productTablesObject }
    },
    [act.SET_URL]: ({ href, canonical }) => ({
      url: { href, canonical },
      ...state,
    }),

    [act.SET_HYDRATION]: (hydrations) => {
      return {
        ...state,
        hydrations,
      }
    },
    [act.SIMPLIFY_CTX]: () => ({ ...state, ctx: simplifyCtx(state.ctx) }),
    default: state,
  })(type, payload)
